/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BatchFileInfo,
    BatchFileInfoFromJSON,
    BatchFileInfoFromJSONTyped,
    BatchFileInfoToJSON,
    BatchProcessingData,
    BatchProcessingDataFromJSON,
    BatchProcessingDataFromJSONTyped,
    BatchProcessingDataToJSON,
    BatchProcessingStatus,
    BatchProcessingStatusFromJSON,
    BatchProcessingStatusFromJSONTyped,
    BatchProcessingStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseFileBatch
 */
export interface CaseFileBatch {
    /**
     * 
     * @type {string}
     * @memberof CaseFileBatch
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileBatch
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileBatch
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileBatch
     */
    startedByUserId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseFileBatch
     */
    batchCreationDate?: Date;
    /**
     * 
     * @type {BatchProcessingStatus}
     * @memberof CaseFileBatch
     */
    status?: BatchProcessingStatus;
    /**
     * 
     * @type {BatchProcessingData}
     * @memberof CaseFileBatch
     */
    data?: BatchProcessingData;
    /**
     * 
     * @type {Array<BatchFileInfo>}
     * @memberof CaseFileBatch
     */
    files?: Array<BatchFileInfo> | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseFileBatch
     */
    batchCompletedTimestamp?: Date | null;
}

export function CaseFileBatchFromJSON(json: any): CaseFileBatch {
    return CaseFileBatchFromJSONTyped(json, false);
}

export function CaseFileBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileBatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'startedByUserId': !exists(json, 'startedByUserId') ? undefined : json['startedByUserId'],
        'batchCreationDate': !exists(json, 'batchCreationDate') ? undefined : (new Date(json['batchCreationDate'])),
        'status': !exists(json, 'status') ? undefined : BatchProcessingStatusFromJSON(json['status']),
        'data': !exists(json, 'data') ? undefined : BatchProcessingDataFromJSON(json['data']),
        'files': !exists(json, 'files') ? undefined : (json['files'] === null ? null : (json['files'] as Array<any>).map(BatchFileInfoFromJSON)),
        'batchCompletedTimestamp': !exists(json, 'batchCompletedTimestamp') ? undefined : (json['batchCompletedTimestamp'] === null ? null : new Date(json['batchCompletedTimestamp'])),
    };
}

export function CaseFileBatchToJSON(value?: CaseFileBatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'caseId': value.caseId,
        'userId': value.userId,
        'startedByUserId': value.startedByUserId,
        'batchCreationDate': value.batchCreationDate === undefined ? undefined : (value.batchCreationDate.toISOString()),
        'status': BatchProcessingStatusToJSON(value.status),
        'data': BatchProcessingDataToJSON(value.data),
        'files': value.files === undefined ? undefined : (value.files === null ? null : (value.files as Array<any>).map(BatchFileInfoToJSON)),
        'batchCompletedTimestamp': value.batchCompletedTimestamp === undefined ? undefined : (value.batchCompletedTimestamp === null ? null : value.batchCompletedTimestamp.toISOString()),
    };
}


